module.exports = __webpack_public_path__ + "static/media/fry.d48a934c.png";